import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'

import BackButton from 'components/BackButton'

interface Props {
  backPath?: string
  backButtonText?: string
}

const ErrorPage: FC<Props> = ({ backPath, backButtonText }) => {
  const { t } = useTranslation()

  return (
    <Container maxWidth="lg">
      <Typography variant="h1" textAlign={'center'}>
        {t('SomethingWentWrong')}
      </Typography>
      <Grid container justifyContent={'center'} mt={2}>
        <BackButton text={backButtonText} link={backPath} />
      </Grid>
    </Container>
  )
}

export default ErrorPage
